var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-nocheck
import { stringify } from 'query-string';
import { fetchUtils } from 'ra-core';
// Ref: https://github.com/marmelab/react-admin/blob/master/packages/ra-data-simple-rest/src/index.ts
var READ = 'GET';
var UPDATE = 'PATCH';
var CREATE = 'POST';
var DELETE = 'DELETE';
var DEFAULT_COUNT_HEADER = 'Content-Range';
var fetchAuthorizedBlob = function (url_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([url_1], args_1, true), void 0, function (url, fallbackType) {
        var token, response, buffer;
        if (fallbackType === void 0) { fallbackType = 'application/octet-stream'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = localStorage.getItem('accessToken');
                    return [4 /*yield*/, fetch(url, {
                            headers: new Headers({
                                Authorization: "Bearer ".concat(token),
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error(response.statusText || "HTTP ".concat(response.status));
                    }
                    return [4 /*yield*/, response.arrayBuffer()];
                case 2:
                    buffer = _a.sent();
                    if (buffer.byteLength === 0) {
                        throw new Error('Downloaded file is empty');
                    }
                    return [2 /*return*/, new Blob([buffer], {
                            type: response.headers.get('content-type') || fallbackType,
                        })];
            }
        });
    });
};
var triggerBlobDownload = function (blob, fileName) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
        link.remove();
        URL.revokeObjectURL(url);
    }, 120000);
};
// let cachedToken = JSON.parse(localStorage.getItem('accessToken')) ?? {}
var cachedToken = localStorage.getItem('accessToken');
var headerOptions = {
    headers: new Headers({
        'Authorization': "Bearer ".concat(cachedToken)
    }),
};
var SenRestProvider = function (apiUrl, countHeader, httpClient) {
    if (countHeader === void 0) { countHeader = DEFAULT_COUNT_HEADER; }
    if (httpClient === void 0) { httpClient = fetchUtils.fetchJson; }
    return ({
        getList: function (resource, params) {
            var _a;
            var _b = params.pagination, page = _b.page, perPage = _b.perPage;
            // localStorage.getItem("myCat")
            var _c = params.sort, field = _c.field, order = _c.order;
            var rangeStart = (page - 1) * perPage;
            var rangeEnd = page * perPage - 1;
            //get filters from sessionstorage
            var sessonStorageJSON = (_a = JSON.parse(sessionStorage.getItem("".concat(window.location.pathname, "_filter")))) !== null && _a !== void 0 ? _a : {};
            var query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([rangeStart, rangeEnd]),
                filter: JSON.stringify(sessonStorageJSON), //[back][0715] resume this when api ready
                // filter: JSON.stringify({}),
            };
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
            // const url = `${apiUrl}/${resource}`; //[back] previously using this on my own
            var options = {
                headers: new Headers({
                    Range: "".concat(resource, "=").concat(rangeStart, "-").concat(rangeEnd),
                    // 'Token': `${cachedToken}`
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            };
            return httpClient(url, options).then(function (_a) {
                var _b;
                var headers = _a.headers, json = _a.json;
                // if (!headers.has(countHeader)) {
                //     throw new Error(
                //         `The ${countHeader} header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare ${countHeader} in the Access-Control-Expose-Headers header?`
                //     );
                // }
                return {
                    data: json,
                    total: countHeader === DEFAULT_COUNT_HEADER
                        ? parseInt((_b = headers.get(DEFAULT_COUNT_HEADER.toLocaleLowerCase())) === null || _b === void 0 ? void 0 : _b.split('/').pop(), 10)
                        : parseInt(headers.get(countHeader.toLowerCase())),
                };
            });
        },
        getListNoFilter: function (resource, params) {
            var _a = params.pagination, page = _a.page, perPage = _a.perPage;
            var _b = params.sort, field = _b.field, order = _b.order;
            var rangeStart = (page - 1) * perPage;
            var rangeEnd = page * perPage - 1;
            var query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([rangeStart, rangeEnd]),
                filter: JSON.stringify(params.filter),
                // filter: JSON.stringify({}),
            };
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
            // const url = `${apiUrl}/${resource}`; //[back] previously using this on my own
            var options = countHeader === DEFAULT_COUNT_HEADER
                ? {
                    headers: new Headers({
                        Range: "".concat(resource, "=").concat(rangeStart, "-").concat(rangeEnd),
                        'Authorization': "Bearer ".concat(cachedToken)
                    }),
                }
                : {};
            return httpClient(url, options).then(function (_a) {
                var _b;
                var headers = _a.headers, json = _a.json;
                // if (!headers.has(countHeader)) {
                //     throw new Error(
                //         `The ${countHeader} header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare ${countHeader} in the Access-Control-Expose-Headers header?`
                //     );
                // }
                return {
                    data: json,
                    total: countHeader === DEFAULT_COUNT_HEADER
                        ? parseInt((_b = headers.get(DEFAULT_COUNT_HEADER.toLocaleLowerCase())) === null || _b === void 0 ? void 0 : _b.split('/').pop(), 10)
                        : parseInt(headers.get(countHeader.toLowerCase())),
                };
            });
        },
        getOneWithoutDataJSON: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.id), headerOptions).then(function (_a) {
                var headers = _a.headers, json = _a.json;
                return (__assign({}, json));
            });
        },
        getOne: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.id), headerOptions).then(function (_a) {
                var headers = _a.headers, json = _a.json;
                return ({
                    data: json,
                });
            });
        },
        getOneExtend: function (resource, id, extResource) {
            // httpClient(`${apiUrl}/${resource}/${params.id}`, {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id, "/").concat(extResource), {
                method: CREATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var headers = _a.headers, json = _a.json;
                return ({ data: json });
            });
        },
        getOneAttribute: function (resource, parentGivenId, givenId) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(parentGivenId, "/").concat(givenId), headerOptions).then(function (_a) {
                var headers = _a.headers, json = _a.json;
                return ({
                    data: json,
                });
            });
        },
        getMany: function (resource, params) {
            var query = {
                filter: JSON.stringify({ id: params.ids }),
            };
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
            return httpClient(url, headerOptions).then(function (_a) {
                var headers = _a.headers, json = _a.json;
                return ({ data: json });
            });
        },
        getManyReference: function (resource, params) {
            var _a;
            var _b = params.pagination, page = _b.page, perPage = _b.perPage;
            var _c = params.sort, field = _c.field, order = _c.order;
            var rangeStart = (page - 1) * perPage;
            var rangeEnd = page * perPage - 1;
            var query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify(__assign(__assign({}, params.filter), (_a = {}, _a[params.target] = params.id, _a))),
            };
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
            var options = countHeader === DEFAULT_COUNT_HEADER
                ? {
                    headers: new Headers({
                        Range: "".concat(resource, "=").concat(rangeStart, "-").concat(rangeEnd),
                        'Authorization': "Bearer ".concat(cachedToken)
                    }),
                }
                : {};
            return httpClient(url, options).then(function (_a) {
                var _b;
                var headers = _a.headers, json = _a.json;
                if (!headers.has(countHeader)) {
                    throw new Error("The ".concat(countHeader, " header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare ").concat(countHeader, " in the Access-Control-Expose-Headers header?"));
                }
                return {
                    data: json,
                    total: countHeader === DEFAULT_COUNT_HEADER
                        ? parseInt((_b = headers.get(DEFAULT_COUNT_HEADER.toLowerCase())) === null || _b === void 0 ? void 0 : _b.split('/').pop(), 10)
                        : parseInt(headers.get(countHeader.toLowerCase())),
                };
            });
        },
        update: function (resource, params) {
            // httpClient(`${apiUrl}/${resource}/${params.id}`, {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.data.givenId), {
                method: UPDATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        updateOne: function (resource, params, id) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        // for update attribute tables
        updateAttribute: function (resource, params, parentGivenId, givenId) {
            // httpClient(`${apiUrl}/${resource}/${params.id}`, {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(parentGivenId, "/").concat(givenId), {
                method: UPDATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        updateMany: function (resource, params) {
            return Promise.all(params.ids.map(function (id) {
                return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
                    method: UPDATE,
                    body: JSON.stringify(params.data),
                    headers: new Headers({
                        'Authorization': "Bearer ".concat(cachedToken)
                    }),
                });
            })).then(function (responses) { return ({ data: responses.map(function (_a) {
                    var json = _a.json;
                    return json.id;
                }), headers: headers }); });
        },
        create: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/"), {
                method: CREATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        createOne: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource), {
                method: CREATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        createAttribute: function (resource, params, parentGivenId, givenId) {
            // httpClient(`${apiUrl}/${resource}/${params.id}`, {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(parentGivenId, "/").concat(givenId), {
                method: CREATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        delete: function (resource, params) {
            var _a;
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat((_a = params === null || params === void 0 ? void 0 : params.data) === null || _a === void 0 ? void 0 : _a.givenId), {
                method: DELETE,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        deleteAttribute: function (resource, params, parentGivenId, givenId) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(parentGivenId, "/").concat(givenId), {
                method: DELETE,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        deleteMany: function (resource, params) {
            return Promise.all(params.ids.map(function (id) {
                return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
                    method: DELETE,
                    headers: new Headers({
                        'Content-Type': 'text/plain',
                        'Authorization': "Bearer ".concat(cachedToken)
                    }),
                });
            })).then(function (responses) { return ({
                data: responses.map(function (_a) {
                    var json = _a.json, headers = _a.headers;
                    return json.id;
                }),
            }); });
        },
        fpPdfUpload: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/pdf/").concat(params.data.parentGivenId, "/").concat(params.data.givenId), {
                method: UPDATE,
                headers: new Headers({
                    // 'Content-Type': 'multipart/form-data',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: params.data.formData,
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        fpUpload: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/fpc/").concat(params.data.parentGivenId, "/").concat(params.data.givenId), {
                method: CREATE,
                headers: new Headers({
                    //     'Content-Type': 'multipart/form-data',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: params.data.formData,
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        fpOneUpdate: function (resource, params, givenId) {
            return httpClient("".concat(apiUrl, "/fp/one/").concat(givenId), {
                method: UPDATE,
                headers: new Headers({
                    //     'Content-Type': 'multipart/form-data',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        fpClassify: function (params) {
            return httpClient("".concat(apiUrl, "/exams/gradingImages"), {
                method: CREATE,
                headers: new Headers({
                    //     'Content-Type': 'multipart/form-data',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        fpOneDelete: function (resource, givenId) {
            return httpClient("".concat(apiUrl, "/fp/one/").concat(givenId), {
                method: DELETE,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        fpOneGet: function (resource, parentId, givenId) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(parentId, "/").concat(givenId), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        triggerExamAnalysis: function (params) { return __awaiter(void 0, void 0, void 0, function () {
            var token, url, response, message, ct, errJson, text, _a, blob, analysisDataPdfUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        token = localStorage.getItem('accessToken');
                        url = "".concat(apiUrl, "/exams/triggerAnalysisPdf");
                        return [4 /*yield*/, fetch(url, {
                                method: CREATE,
                                body: JSON.stringify(params.data),
                                headers: new Headers({
                                    Authorization: "Bearer ".concat(token),
                                    'Content-Type': 'application/json',
                                    Accept: 'application/pdf',
                                }),
                            })];
                    case 1:
                        response = _b.sent();
                        if (!!response.ok) return [3 /*break*/, 9];
                        message = response.statusText || "HTTP ".concat(response.status);
                        ct = response.headers.get('Content-Type') || '';
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, , 8]);
                        if (!ct.includes('application/json')) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        errJson = _b.sent();
                        message = errJson.message || errJson.error || JSON.stringify(errJson);
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, response.text()];
                    case 5:
                        text = _b.sent();
                        if (text)
                            message = text.slice(0, 500);
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        _a = _b.sent();
                        return [3 /*break*/, 8];
                    case 8: throw new Error(message);
                    case 9: return [4 /*yield*/, response.blob()];
                    case 10:
                        blob = _b.sent();
                        analysisDataPdfUrl = response.headers.get('X-Analysis-Data-Pdf-Url') ||
                            response.headers.get('x-analysis-data-pdf-url');
                        return [2 /*return*/, { data: { blob: blob, analysisDataPdfUrl: analysisDataPdfUrl } }];
                }
            });
        }); },
        shareReportByEmail: function (params) {
            return httpClient("".concat(apiUrl, "/sharing/report/email"), {
                method: CREATE,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        createReportQrShare: function (params) {
            return httpClient("".concat(apiUrl, "/sharing/report/qr"), {
                method: CREATE,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        dataExport: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/data/export"), {
                method: CREATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        // login/pw related
        changePW: function (params) {
            return httpClient("".concat(apiUrl, "/auth/changePW"), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        /* dashboard */
        totalSubjects: function (resource) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/count/subject/created"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        totalSubjectsOrg: function (resource) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/count/subject/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        totalSubjectsRep: function (resource) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/count/report/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        totalExams: function (resource) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/count/exam/created"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        totalExamsOrg: function (resource) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/count/exam/created/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        FinishedExams: function (resource) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/count/exam/finished/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        /*   your org left bar chart */
        UrOrgleftbar: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/highRisk/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        /* your org pie chart */
        UrOrgPie1: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/finishedExam/confidence/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        UrOrgPie2: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/finishedExam/eye/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        UrOrgPie3: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/finishedExam/AIModel/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        UrOrgPie4: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/gender/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        UrOrgPie5: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/eduLevel/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        UrOrgPie6: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/age/org"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        /* All Org  */
        Card1: function () {
            return httpClient("".concat(apiUrl, "/dashboard/count/subject/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        Card2: function () {
            return httpClient("".concat(apiUrl, "/dashboard/count/exam/created/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        Card4: function () {
            return httpClient("".concat(apiUrl, "/dashboard/count/exam/finished/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        /*   All org left bar */
        AllOrgleftbar: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/highRisk/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        /* All org pie chart */
        AllOrgPie1: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/finishedExam/confidence/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        AllOrgPie2: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/finishedExam/eye/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        AllOrgPie3: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/finishedExam/AIModel/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        AllOrgPie4: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/gender/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        AllOrgPie5: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/edulevel/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        AllOrgPie6: function () {
            return httpClient("".concat(apiUrl, "/dashboard/distribution/subject/age/all"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        ShowUrOrg: function (params) {
            return httpClient("".concat(apiUrl, "/users/").concat(params.id), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        GetProducts: function () {
            return httpClient("".concat(apiUrl, "/payment/products"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        DeleteProduct: function (key) {
            return httpClient("".concat(apiUrl, "/payment/products/").concat(key), {
                method: DELETE,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        CreatePackage: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/"), {
                method: CREATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        EditPackage: function (resource, params) {
            // httpClient(`${apiUrl}/${resource}/${params.id}`, {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.key), {
                method: UPDATE,
                body: JSON.stringify(params.data),
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        DisableUser: function (resource, params, id) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/disable/").concat(id), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        unblock: function (resource, params) {
            return httpClient("".concat(apiUrl, "/auth/banip/").concat(params.data.id), {
                method: DELETE,
                headers: new Headers({
                    'Content-Type': 'text/plain',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json, headers = _a.headers;
                return ({ data: json });
            });
        },
        // Define the error limit update function
        updateErrorLimit: function (resource, params) {
            return httpClient("".concat(apiUrl, "/auth/errorLimit/").concat(params.id), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // Define the fetch error limits function
        getErrorLimits: function (resource) {
            return httpClient("".concat(apiUrl, "/auth/errorLimit"), {
                method: READ,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // Get invoice data
        getInvoiceData: function (id) {
            return httpClient("".concat(apiUrl, "/payment/invoice/").concat(id), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // Upload invoice PDF
        uploadInvoicePdf: function (resource, params) {
            var formData = new FormData();
            formData.append('pdf', params.data.file, "invoice-".concat(params.data.id, ".pdf"));
            return httpClient("".concat(apiUrl, "/payment/records/").concat(params.data.id, "/invoice"), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: formData,
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        uploadBatch: function (_resource, params) {
            var formData = new FormData();
            formData.append('archive', params.data.file, params.data.file.name);
            if (params.data.name) {
                formData.append('name', params.data.name);
            }
            return httpClient("".concat(apiUrl, "/batches"), {
                method: CREATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: formData,
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        getBatchHistory: function (page, perPage) {
            var rangeStart = (page - 1) * perPage;
            var rangeEnd = page * perPage - 1;
            var query = stringify({ range: JSON.stringify([rangeStart, rangeEnd]) });
            return httpClient("".concat(apiUrl, "/batches?").concat(query), {
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var _b;
                var headers = _a.headers, json = _a.json;
                return ({
                    data: json,
                    total: parseInt(((_b = headers.get(DEFAULT_COUNT_HEADER.toLowerCase())) === null || _b === void 0 ? void 0 : _b.split('/').pop()) || '0', 10),
                });
            });
        },
        getBatch: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId), headerOptions)
                .then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        getBatchSubjects: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId, "/subjects"), headerOptions)
                .then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        getBatchExams: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId, "/exams"), headerOptions)
                .then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        getBatchExam: function (subjectId, examId) {
            return httpClient("".concat(apiUrl, "/exams/").concat(subjectId, "/").concat(examId), headerOptions)
                .then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        reconcileBatchStatus: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId, "/reconcile-status"), {
                method: CREATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        deleteBatch: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId), {
                method: DELETE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        createBatchReport: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId, "/reports"), {
                method: CREATE,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify({}),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        getReportJob: function (reportJobId) {
            return httpClient("".concat(apiUrl, "/report-jobs/").concat(reportJobId), headerOptions)
                .then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        getReportTasks: function (reportJobId) {
            return httpClient("".concat(apiUrl, "/report-jobs/").concat(reportJobId, "/tasks"), headerOptions)
                .then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        retryBatchImport: function (batchId) {
            return httpClient("".concat(apiUrl, "/batches/").concat(batchId, "/retry-import"), {
                method: CREATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        retryReportTasks: function (reportJobId) {
            return httpClient("".concat(apiUrl, "/report-jobs/").concat(reportJobId, "/retry-failed"), {
                method: CREATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        downloadBatchArchive: function (batchId, fileName) { return __awaiter(void 0, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAuthorizedBlob("".concat(apiUrl, "/batches/").concat(batchId, "/archive"), 'application/zip')];
                    case 1:
                        blob = _a.sent();
                        triggerBlobDownload(blob, fileName);
                        return [2 /*return*/];
                }
            });
        }); },
        downloadBatchReports: function (batchId, fileName) { return __awaiter(void 0, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAuthorizedBlob("".concat(apiUrl, "/batches/").concat(batchId, "/reports/archive"), 'application/zip')];
                    case 1:
                        blob = _a.sent();
                        triggerBlobDownload(blob, fileName);
                        return [2 /*return*/];
                }
            });
        }); },
        // Get Cooperation data
        getCooperationData: function () {
            return httpClient("".concat(apiUrl, "/dashboard/api/monthlyAccess/analyse"), {
                method: READ,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // Enable API access for client
        enableApiAccess: function (clientName) {
            return httpClient("".concat(apiUrl, "/dashboard/api/").concat(clientName, "/enable"), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // Disable API access for client 
        disableApiAccess: function (clientName) {
            return httpClient("".concat(apiUrl, "/dashboard/api/").concat(clientName, "/disable"), {
                method: UPDATE,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // Create trial user
        createTrialUser: function (params) {
            return httpClient("".concat(apiUrl, "/users/trial"), {
                method: CREATE,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
                body: JSON.stringify({
                    username: params.data.username,
                    email: params.data.email,
                    password: params.data.password,
                    Last_name: params.data.Last_name,
                    First_name: params.data.First_name,
                    gender: params.data.gender,
                    organizationName: params.data.organizationName,
                    trialDay: Number(params.data.trialDay),
                    quota: Number(params.data.quota)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        // About Maintanence Notification
        getMaintanenceNotification: function () {
            return httpClient("".concat(apiUrl, "/maintenance-notification/active"), {
                method: READ,
                headers: new Headers({
                    'Authorization': "Bearer ".concat(cachedToken)
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        }
    });
};
export default SenRestProvider;
